import { AlarmConfiguration } from 'domain/alarm-configuration'
import { useAuth } from 'layout/context/auth-context'
import { useLoading } from 'layout/context/loading-context'
import { useSignalR } from 'layout/context/signalr-context'
import { Card } from 'primereact/card'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { TabPanel, TabView } from 'primereact/tabview'
import { useEffect, useRef, useState } from 'react'
import { useAlarm } from '../hooks/useAlarm'
import AlarmConfigurationsTable from './alarm-configurations-table'
import AlarmEventDetailDialog from './alarm-event-detail-dialog'
import AlarmEventsTable from './alarm-events-table'
import './alarms-view.scss'
import AlarmDialog from './new-alarm-dialog'
import { AlarmOutput } from 'domain/alarm-output'

const AlarmsView = () => {

  const { clientId } = useAuth()
  const { isLoading } = useLoading()
  const { markAlarmsAsRead } = useSignalR()
  const containerRef = useRef<HTMLDivElement>(null)
  const {
    alarmConfigurations,
    alarmEvents,
    totalEvents,
    fetchAlarmConfigurations,
    deleteAlarmConfiguration,

    fetchAlarmEvents,
  } = useAlarm()

  const [newConfigDialog, setNewConfigDialog] = useState<boolean>(false)
  const [selectedEvent, setSelectedEvent] = useState<AlarmOutput | null>(null)
  const [eventDetailDialog, setEventDetailDialog] = useState<boolean>(false)
  const [activeIndex, setActiveIndex] = useState<number>(0)

  useEffect(() => {
    if (clientId) {
      fetchAlarmConfigurations({ clientId })
      fetchAlarmEvents({ clientId })
    }
  }, [clientId])

  // Visitar a tela conta como "ler" os alarmes recebidos nesta sessão,
  // independente de o usuário ter aberto o sino ou navegado direto pra cá.
  useEffect(() => {
    markAlarmsAsRead()
  }, [])

  const confirmDeleteConfiguration = (configuration: AlarmConfiguration) => {
    confirmDialog({
      message: 'Tem certeza que deseja excluir esta configuração de alarme?',
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => handleDeleteConfiguration(configuration),
    })
  }
  const handleDeleteConfiguration = async (
    configuration: AlarmConfiguration
  ) => {
    await deleteAlarmConfiguration(configuration.id)
  }
  const showEventDetails = (event: AlarmOutput) => {
    setSelectedEvent(event)
    setEventDetailDialog(true)
  }
  const hideEventDetailsDialog = () => {
    setEventDetailDialog(false)
  }

  return (
    <div
      className='alarms-container'
      ref={containerRef}
    >
      <div className='alarms-header'>
        <div className='alarms-title-section'>
          <i className='pi pi-shield alarms-main-icon' />
          <h1 className='alarms-title'>Gestão de Alarmes</h1>
        </div>
        <div className='alarms-subtitle'>
          Configure e monitore alarmes de segurança em tempo real
        </div>
      </div>

      <Card className='alarms-card'>
        <ConfirmDialog
          className='alarms-confirm-dialog'
          appendTo={containerRef.current}
        />

        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className='alarms-tabview'
        >
          <TabPanel
            header='Configurações'
            leftIcon='pi pi-cog mr-2'
            className='alarms-tab-config'
          >
            <AlarmConfigurationsTable
              alarmConfigurations={alarmConfigurations}
              totalConfigurations={alarmConfigurations.length}
              isLoading={isLoading}
              onNewConfiguration={() => setNewConfigDialog(true)}
              onDeleteConfiguration={confirmDeleteConfiguration}
            />
          </TabPanel>

          <TabPanel
            header='Histórico de Eventos'
            leftIcon='pi pi-history mr-2'
            className='alarms-tab-events'
          >
            <AlarmEventsTable
              alarmEvents={alarmEvents}
              totalEvents={totalEvents}
              isLoading={isLoading}
              onViewDetails={showEventDetails}
            />
          </TabPanel>
        </TabView>

        <AlarmDialog
          container={containerRef.current}
          showDialog={newConfigDialog}
          hideDialog={() => {
            setNewConfigDialog(false)
          }}
          onSuccess={() => {
            if (clientId) {
              fetchAlarmConfigurations({ clientId })
            }
          }}
        />

        <AlarmEventDetailDialog
          container={containerRef.current}
          visible={eventDetailDialog}
          selectedEvent={selectedEvent}
          onHide={hideEventDetailsDialog}
        />
      </Card>
    </div>
  )
}

export default AlarmsView
